import KYCPreForm from "@/pages/user/components/KYCPreForm";
import {Box} from "@mui/material";
import {useTranslation} from "react-i18next";

function GuideKYCPre() {
  const {t} = useTranslation();

  return (
    <Box style={{padding: '24px', minHeight: '280px'}}>
      <KYCPreForm/>
    </Box>
  )
}

export default GuideKYCPre
